<template>
  <v-container class="d-flex justify-center">
    <v-card v-if="!success" class="pa-4" width="500">
      <v-card-title class="pa-0 justify-center">Unsubscribe {{ email }}</v-card-title>
      <br />

      <p id="errorMsg" class="red--text" hidden>No account is registered with the email {{ failedEmail }}</p>

      <div class="d-flex justify-center">
        <v-btn @click="unsubscribe" color="accent" :loading="loading">Unsubscribe</v-btn>
      </div>
    </v-card>

    <v-card v-else class="pa-4" width="500">
      <v-card-title class="px-0">
        The following email has been unsubscribed:<br />
        {{ email }}.
      </v-card-title>
      <v-card-text class="px-0 black--text">
        To reactivate this address, send an email to
        <a href="mailto:support@telemonial.com">support@telemonial.com</a>. You may have to check your spam folder for
        any responses.
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import jwtDecode from "jwt-decode";

export default {
  name: "unsubscribe-page",

  data: function () {
    return {
      email: "",

      loading: false,
      success: false,
    };
  },

  mounted: async function () {
    const token = this.$route.params.token;
    this.email = jwtDecode(token).email;
  },

  methods: {
    ...mapMutations(["showSnackbar"]),

    unsubscribe: function () {
      this.loading = true;
      this.$axios
        .put("/v1/emails/unsubscribed", {
          email: this.email,
          token: this.$route.params.token,
        })
        .then(() => {
          // Notify user that email has been sent
          this.success = true;
          document.getElementById("errorMsg").hidden = true;
        })
        .catch(() => {
          this.showSnackbar({
            text: "An unexpected error has occurred!",
            error: true,
          });
        });
    },
  },
};
</script>
